
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TtkList from './TtkList';
const TourPackageTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Price:</b>&nbsp;<span>{data?.price}</span></p>
                        </div>


                        <div className='col-md-4'>
                            <p> <DirectionsCarIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travelling Vehicle Type :</b>&nbsp;<TtkList data={data?.travellingType} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p ><GroupWorkIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.travelPreference} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Tour Provided in Areas :</b>&nbsp;<TtkList data={data?.tourProvided} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <AccessTimeFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Tour Duration :</b>&nbsp;<TtkList data={data?.durationType} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}

export default TourPackageTTK